import en from "./en";
import fi from "./fi";
import sv from "./sv";
var dateTimeFormat = {
    date: { year: "numeric", month: "long", day: "numeric", hour12: false },
    time: { hour: "numeric", minute: "numeric", second: "numeric", hour12: false },
    full: {
        year: "numeric", month: "long", day: "numeric",
        hour: "numeric", minute: "numeric", second: "numeric", hour12: false
    }
};
var numberFormat = {
    currency: { style: "currency", currency: "EUR" }
};
export default {
    enabledLocales: ["en", "fi", "sv"],
    messages: { en: en, fi: fi, sv: sv },
    dateTimeFormats: {
        en: dateTimeFormat,
        fi: dateTimeFormat,
        sv: dateTimeFormat,
    },
    numberFormats: {
        en: numberFormat,
        fi: numberFormat,
        sv: numberFormat,
    }
};
